"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeContextProvider = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SizeContext = React.createContext(undefined);
var SizeContextProvider = function (_a) {
    var children = _a.children, size = _a.size;
    return (React.createElement(SizeContext.Consumer, null, function (originSize) { return (React.createElement(SizeContext.Provider, { value: size || originSize }, children)); }));
};
exports.SizeContextProvider = SizeContextProvider;
exports.default = SizeContext;
//# sourceMappingURL=SizeContext.js.map